<template>
    <defs>
    <pattern id="diagonalStripes" patternUnits="userSpaceOnUse" width="40" height="40" patternTransform="rotate(45)">
      <rect width="40" height="40" fill="#A76C5A" />
      <rect x="0" y="0" width="20" height="40" fill="#6E2F1FB2" />
    </pattern>
  </defs>
</template>